// effects/fadeObserver.js
const rm = matchMedia("(prefers-reduced-motion: reduce)");

function setStagger(list, { base = 0, step = 0.08 } = {}) {
  list.forEach((el, i) => el.style.setProperty("--delay", `${base + i * step}s`));
}

function reveal(el, observer) {
  el.classList.add("is-visible");
  if (observer) observer.unobserve(el);
}

// % を px に変換（top/bottom は vh、left/right は vw 基準）
function toPxRootMargin(margin) {
  if (!margin || typeof margin !== "string" || !margin.includes("%")) return margin;
  const parts = margin.trim().split(/\s+/);
  const norm = parts.length === 1 ? [parts[0], parts[0], parts[0], parts[0]] : parts.length === 2 ? [parts[0], parts[1], parts[0], parts[1]] : parts.length === 3 ? [parts[0], parts[1], parts[2], parts[1]] : parts.slice(0, 4);

  const vh = window.innerHeight;
  const vw = window.innerWidth;
  const conv = (val, vertical) => {
    if (typeof val === "string" && val.endsWith("%")) {
      const n = parseFloat(val);
      const px = (vertical ? vh : vw) * (n / 100);
      return `${px}px`;
    }
    // "0" のような単位無しは px を付ける
    if (/^-?\d+(\.\d+)?$/.test(val)) return `${val}px`;
    return val; // 既に px
  };

  const [t, r, b, l] = norm;
  return [conv(t, true), conv(r, false), conv(b, true), conv(l, false)].join(" ");
}

// Safari などで % がダメな場合のフォールバック生成
function createObserver(callback, options) {
  try {
    return new IntersectionObserver(callback, options);
  } catch (e) {
    if (options && typeof options.rootMargin === "string" && options.rootMargin.includes("%")) {
      const pxMargin = toPxRootMargin(options.rootMargin);
      return new IntersectionObserver(callback, { ...options, rootMargin: pxMargin });
    }
    throw e;
  }
}

/** ふつうのセクション用 */
export function revealSection(selector = ".reveal", io = { rootMargin: "0% 0% -12% 0", threshold: 0 }) {
  const targets = [...document.querySelectorAll(selector)];
  if (!targets.length) return;

  if (rm.matches) {
    targets.forEach((el) => el.classList.add("is-visible"));
    return;
  }

  const observer = createObserver((entries) => {
    entries.forEach((e) => e.isIntersecting && reveal(e.target, observer));
  }, io);

  targets.forEach((el) => observer.observe(el));
  return () => observer.disconnect();
}

/** FV（読み込み時） */
export function revealOnLoad(selector = ".js-fv .reveal", { base = 0.2, step = 0.06 } = {}) {
  const els = [...document.querySelectorAll(selector)];
  if (!els.length) return;

  if (rm.matches) {
    els.forEach((el) => el.classList.add("is-visible"));
    return;
  }

  setStagger(els, { base, step });
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      els.forEach((el) => el.classList.add("is-visible"));
    });
  });
}

/** 連続表示（コンテナ内を順番に） */
export function revealSequence(containerSelector = ".js-stagger", itemSelector = ".reveal", io = { rootMargin: "0% 0% -12% 0", threshold: 0 }, { base = 0, step = 0.08 } = {}) {
  const containers = [...document.querySelectorAll(containerSelector)];
  if (!containers.length) return;

  if (rm.matches) {
    containers.forEach((c) => c.querySelectorAll(itemSelector).forEach((el) => el.classList.add("is-visible")));
    return;
  }

  const observer = createObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const items = [...e.target.querySelectorAll(itemSelector)];
      setStagger(items, { base, step });
      items.forEach((el) => reveal(el));
      observer.unobserve(e.target);
    });
  }, io);

  containers.forEach((c) => observer.observe(c));
  return () => observer.disconnect();
}
